<template>
  <div v-if="effectiveUnreadCount > 0" :class="classes">
    {{ effectiveUnreadCount }}
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'

import { getUnreadChecksCount } from '../api'
import { SfLog } from '@app/adapters/logger'

import { useSfAssistantChecksPage } from '@app/application/sf-assistant-checks/stores/page'

interface Props {
  className?: string
  workflowId?: number
}

const props = defineProps<Props>()

const unreadCountAPI = ref<number | null>(null)

const classes = computed(() => {
  return (
    props.className ||
    'sf-label sf-label-danger sf-label-active sf-no-border tw-flex tw-items-center tw-justify-center tw-h-4 tw-min-w-[16px] tw-rounded-full tw-px-1 tw-leading-3'
  )
})

const sfAssistantChecksPageStore = useSfAssistantChecksPage()

const { totalUnreadCheckCount } = storeToRefs(sfAssistantChecksPageStore)

fetchUnreadCount()

const effectiveUnreadCount = computed(() => {
  // If the assistant page store is mounted, use the computed unread property
  // Otherwise rely purely on the API response
  return totalUnreadCheckCount.value !== null
    ? totalUnreadCheckCount.value
    : unreadCountAPI.value ?? 0
})

async function fetchUnreadCount(): Promise<void> {
  try {
    const data = await getUnreadChecksCount(props.workflowId)
    if (data) {
      unreadCountAPI.value = data.count
    }
  } catch (error) {
    SfLog.warn('Failed to load unread checks count', {
      extra: {
        ...window.Silverfin.jsonParams,
        error,
      },
    })
  }
}
</script>
